export const documentationLink = 'https://help.sap.com/docs/signavio-process-governance';
export const userGuideLink = `${documentationLink}/user-guide`;
export const developerGuideLink = `${documentationLink}/developer-guide`;